/**
 * @generated SignedSource<<0d9b185c29705c8d5c5e9e02f1ae721c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FunnelImportContainer_Query$variables = {
  siteSlug: string;
};
export type FunnelImportContainer_QueryVariables = FunnelImportContainer_Query$variables;
export type FunnelImportContainer_Query$data = {
  readonly site: {
    readonly id: string;
  };
};
export type FunnelImportContainer_QueryResponse = FunnelImportContainer_Query$data;
export type FunnelImportContainer_Query = {
  variables: FunnelImportContainer_QueryVariables;
  response: FunnelImportContainer_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteSlug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "siteSlug"
      }
    ],
    "concreteType": "Site",
    "kind": "LinkedField",
    "name": "site",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelImportContainer_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FunnelImportContainer_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e800ac9bdba17a657979320dee57f157",
    "id": null,
    "metadata": {},
    "name": "FunnelImportContainer_Query",
    "operationKind": "query",
    "text": "query FunnelImportContainer_Query(\n  $siteSlug: String!\n) {\n  site(slug: $siteSlug) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b693a2eeb3a9662534188bd74a8def5";

export default node;
